module.exports = __webpack_public_path__ + "6bf4fabad5fbfac09fadc4f0cda3fa65.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/itcavantgardestd-bk-webfont.woff
 ** module id = 371
 ** module chunks = 0
 **/